import { useState } from "react";

import styled from "styled-components";

import { ButtonLink } from "~/components/Button";
import { Separator } from "~/components/Elements";
import * as Form from "~/components/Form";
import Modal from "~/components/Modal";
import Spacer, { Axis } from "~/components/Spacer";

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
`;
const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;
const TitleText = styled.div`
  font-size: 32px;
  font-weight: 800;
  line-height: 40px;
`;

type DDQModalApproveProps = {
  onSubmit?: (requestDDQAcess: boolean) => void;
  onClose: () => void;
  vaspName: string;
};

export default function DDQModalApprove({ onSubmit, onClose, vaspName }: DDQModalApproveProps) {
  const [requestDDQAcess, setRequestDDQAccess] = useState(false);

  const onSubmitClick = () => {
    if (onSubmit) {
      onSubmit(requestDDQAcess);
    }
  };

  return (
    <>
      <Modal active onClose={onClose}>
        <Modal.Body
          styles={{
            display: "flex",
            flexDirection: "column",
            maxWidth: 540,
          }}
        >
          <TitleText>Approve {vaspName} access to your DDQ</TitleText>
          <Spacer axis={Axis.VERTICAL} size={10} />
          <MainContent>
            <Separator style={{ width: "100%", backgroundColor: "#D2D2D2" }} sized={null} />
            <Form.CheckboxLabel style={{ width: "100%" }}>
              <Form.CheckboxInput onChange={(e) => setRequestDDQAccess(e.target.checked)}></Form.CheckboxInput>
              <Form.CheckboxText>Send a request to access their DDQ</Form.CheckboxText>
            </Form.CheckboxLabel>
          </MainContent>
        </Modal.Body>
        <Modal.Footer>
          <SpaceBetween>
            <ButtonLink onClick={onClose}>Close</ButtonLink>
            <ButtonLink color="success" onClick={onSubmitClick}>
              Approve access
            </ButtonLink>
          </SpaceBetween>
        </Modal.Footer>
      </Modal>
    </>
  );
}
